const getYearsRange = (start: Date, end: Date): string[] => {
  const startYear = start.getFullYear()
  const endYear = end.getFullYear()
  return Array(endYear - startYear + 1)
    .fill(undefined)
    .map((_, i) => `${startYear + i}`)
}

export default getYearsRange
